import {useMemo} from 'react'
import {GetFormattedBulkPointModifiers} from '@/models/BulkModifierModel'
import {useDataTable} from '@/hooks/useDataTable-hook'
import {getBulkModifiers} from '@/services/bulkModifiers'
import {BulkModifiersListColConfig} from '@/services/MockData/BulkModifiersList/BulkModifiersListColConfig'
import {useQueries} from '@tanstack/react-query'

export const useBulkModifiers = () => {
  const {setPageIndex, setSortingObj, setSearchArry, pageIndex, sortingObj, searchArr, handleResetAll} = useDataTable()

  // Move search params to request body and only use query params for pagination/sorting
  const queryParams = useMemo(() => {
    const params = new URLSearchParams()

    // Add sorting parameters if available
    if (sortingObj?.column) {
      params.append('sortBy', sortingObj.column)
      params.append('order', sortingObj.direction)
    }

    // Add pagination parameters
    params.append('pageSize', 10)
    params.append('page', pageIndex || 0)

    //this code can be used to filter the data based on the searchArr

    // // Add search parameters if available
    // if (searchArr.length > 0) {
    //   searchArr.forEach(searchObj => {
    //     if (searchObj.type === 'date') {
    //       // params.append(searchObj.field, getFormattedDateString(searchObj.value))
    //     } else {
    //       // params.append(searchObj.field, searchObj.value)
    //     }
    //   })
    // }

    return params.toString()
  }, [sortingObj?.column, sortingObj?.direction, pageIndex])

  const [{data, isLoading, isFetching}] = useQueries({
    queries: [
      {
        queryKey: ['BULK_MODIFIERS', queryParams, searchArr],
        queryFn: () => getBulkModifiers(queryParams, searchArr),
      },
    ],
  })

  const resultsData = useMemo(() => data || {}, [data])
  const bulkModifiersData = useMemo(() => GetFormattedBulkPointModifiers(resultsData), [resultsData])

  return {
    bulkModifiersData,
    bulkModifiersColConfigData: BulkModifiersListColConfig,
    isLoading: isLoading,
    isFetching: isFetching,
    setPageIndex,
    setSortingObj,
    setSearchArry,
    pageIndex,
    sortingObj,
    searchArr,
    handleResetAll,
  }
}
